// import { collection, getDocs, query, where } from "@firebase/firestore"
// import { db } from "../firebase"

// export default class Lead {
//     constructor() {
//         this.KEY = 'Lead'
//     }
//     async providerRequestsCount(provider_phone) {
//         try {
//             const newLeadQ = query(collection(db, this.KEY),
//                 where("provider_phone", "==", provider_phone),
//             )
//             const snapshot = getDocs(newLeadQ)
//             return (await snapshot).size
//         } catch (error) {
//             console.error(error, { provider_phone });
//         }
//     }
// }



import { collection, getDocs, query, where } from "@firebase/firestore";
import { db } from "../firebase";

export default class Lead {
    constructor() {
        this.KEY = 'Lead';
    }

    async providerRequestsCount(provider_phone) {
        if (!provider_phone) {
            console.warn("Invalid provider_phone:", provider_phone);
            return 0;
        }

        try {
            const newLeadQ = query(
                collection(db, this.KEY),
                where("provider_phone", "==", provider_phone)
            );

            const snapshot = await getDocs(newLeadQ);
            return snapshot.size;
        } catch (error) {
            console.error("Error in providerRequestsCount:", error, { provider_phone });
            throw error; // Optional: Re-throw if you want to handle upstream
        }
    }
}
